import { useState, useEffect } from "react";
import { useActiveSection } from "../../hooks/useActiveSection";
import { siteConfig } from "../../data/portfolioData";

const NAV_ITEMS = [
  { id: "work", label: "Work" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const activeSection = useActiveSection(["hero", ...NAV_ITEMS.map((n) => n.id)]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-carbon-950/95 backdrop-blur-sm border-b border-carbon-800"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-16">
        {/* Logo */}
        <button
          onClick={() => scrollTo("hero")}
          className="font-display text-xl tracking-widest text-ash-100 hover:text-ember-400 transition-colors duration-300"
        >
          {siteConfig.name.split(" ")[0]}
          <span className="text-ember-400">.</span>
        </button>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => scrollTo(item.id)}
                className={`nav-link font-body text-sm tracking-widest uppercase transition-colors duration-300 ${
                  activeSection === item.id
                    ? "text-ember-400 active"
                    : "text-ash-400 hover:text-ash-100"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => scrollTo("contact")}
              className="ml-4 px-5 py-2 border border-ember-400 text-ember-400 font-body text-sm tracking-widest uppercase hover:bg-ember-400 hover:text-carbon-950 transition-all duration-300"
            >
              Hire Me
            </button>
          </li>
        </ul>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-px bg-ash-100 transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-2.5" : ""
            }`}
          />
          <span
            className={`block w-6 h-px bg-ash-100 transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block w-6 h-px bg-ash-100 transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-2.5" : ""
            }`}
          />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-500 overflow-hidden ${
          menuOpen ? "max-h-96 border-b border-carbon-800" : "max-h-0"
        } bg-carbon-950/98 backdrop-blur-sm`}
      >
        <ul className="flex flex-col px-6 py-6 gap-6">
          {NAV_ITEMS.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => scrollTo(item.id)}
                className={`font-heading text-2xl tracking-widest uppercase ${
                  activeSection === item.id ? "text-ember-400" : "text-ash-200"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
